export enum ORIGIN {
    MAXHUB = 1,
    MOBILE = 2
  }
  
  export const defaultMessageTimeout = 15000;
  
  export enum ResponseError {
    // 超时
    timeout = 'timeout'
  }
  
  export enum CbTypeKey {
    connectCb = 'connectCb',
    recvMsgCb = 'recvMsgCb',
    reConnectCb = 'reConnectCb',
    disconnectCb = 'disconnectCb',
    onSingleCommandRecvCb = 'onSingleCommandRecvCb'
  }
  
  export const USER_ID_KEY = 'meeting-uid';
  export const USER_INFO_KEY = 'meeting-im-userInfo';
  
  export const UidTokenIllegalCode = 116;
  export const WebPlatForm = 4;
  export const getRoomInfoFailedCode = 60005;
  export const roomDeletedNotifyId = 202;
  